import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Disclosure } from 'Components/ComponentLibrary/Organisms/Disclosure/Disclosure';

export const overrideSet = buildFacetDesignOverride()
  .nameOverride('disclosure', {
    _component: () => Disclosure,
  }, overrideReadOnly);
